const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': '你好',
    'Ref: Page content body': '到達和出發時，請務必掃描車輛二維碼',
  },
};
export default labels;
